/**
 * @generated SignedSource<<574d5c7867a935af7314d09c306dfbfb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProvisionPortalUserInput = {
  clientOrgId: string;
  clientContactId: string;
  email: string;
  roleKey: string;
  clientName?: string | null;
  scopeLevel?: string | null;
  scopeProgrammeIds?: ReadonlyArray<string | null> | null;
  scopeProjectIds?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type provisionPortalUserMutation$variables = {
  input: ProvisionPortalUserInput;
};
export type provisionPortalUserMutation$data = {
  readonly provisionPortalUser: {
    readonly portalUsers: ReadonlyArray<{
      readonly id: string | null;
      readonly email: string | null;
      readonly roleKey: string | null;
      readonly status: string | null;
      readonly scopeLevel: string | null;
      readonly scopeProgrammeIds: ReadonlyArray<string | null> | null;
      readonly scopeProjectIds: ReadonlyArray<string | null> | null;
    } | null> | null;
  } | null;
};
export type provisionPortalUserMutation = {
  variables: provisionPortalUserMutation$variables;
  response: provisionPortalUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProvisionPortalUserPayload",
    "kind": "LinkedField",
    "name": "provisionPortalUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PortalUser",
        "kind": "LinkedField",
        "name": "portalUsers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roleKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopeLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopeProgrammeIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopeProjectIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "provisionPortalUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "provisionPortalUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "acd806d14b091f5ef51d166377695ce3",
    "id": null,
    "metadata": {},
    "name": "provisionPortalUserMutation",
    "operationKind": "mutation",
    "text": "mutation provisionPortalUserMutation(\n  $input: ProvisionPortalUserInput!\n) {\n  provisionPortalUser(input: $input) {\n    portalUsers {\n      id\n      email\n      roleKey\n      status\n      scopeLevel\n      scopeProgrammeIds\n      scopeProjectIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "874a2f43fa94e99954118fdb0d557d58";

export default node;
